import React, { useContext } from "react";
import {buyNowContext} from "../BuyNow";
import {PURCHASE_FLOWS} from "../../../../constants";
import BPAddonSelection from "./BPAddonSelection";
import GeneralProductSelection from "./GeneralProductSelection";
import ClinicianProductSelection from "./ClinicianProductSelection";
import ClearStepParentProductSelection from "./ClearStepParentProductSelection";
import ThermometerAddonSelection from "./ThermometerAddonSelection";

const ProductSelection = () => {
  const { purchaseFlow } = useContext(buyNowContext);

  if (purchaseFlow === PURCHASE_FLOWS.SHAPA_END_USER || purchaseFlow === PURCHASE_FLOWS.CLEARSTEP_END_USER || purchaseFlow === PURCHASE_FLOWS.SHAPA_HEALTH_END_USER)
    return <GeneralProductSelection />;
  else if (purchaseFlow === PURCHASE_FLOWS.CLEARSTEP_CLINICIAN || purchaseFlow === PURCHASE_FLOWS.SHAPA_HEALTH_CLINICIAN)
    return <ClinicianProductSelection />;
  else if (purchaseFlow === PURCHASE_FLOWS.SHAPA_BP_ADDON || purchaseFlow === PURCHASE_FLOWS.CLEARSTEP_BP_ADDON)
    return <BPAddonSelection />;
  else if (purchaseFlow === PURCHASE_FLOWS.SHAPA_THERMOMETER_ADDON || purchaseFlow === PURCHASE_FLOWS.CLEARSTEP_THERMOMETER_ADDON)
    return <ThermometerAddonSelection />;
  else if (purchaseFlow === PURCHASE_FLOWS.CLEARSTEP_PARENT)
    return <ClearStepParentProductSelection />;
};

export default ProductSelection;
